import React from "react";
import "../styles/OurTeam.css";
import Card from "./Reusable/Card";
import madhviAvatar from "../images/madhvi-avatar.jpg";
import pranitaAvatar from "../images/pranita-avatar.jpg";
import ehteshamAvatar from "../images/ehtesham-avatar.jpg";
import imranAvatar from "../images/imran-avatar.jpg";

const chapterLeads = [
  {
    id: 1,
    name: "Madhavi Soni",
    bio:
      "Madhavi is a Computer Graduate from University of Mumbai. Currently playing with Python and developing Web Apps. A technical content writer, also she writes blog on Mandala Designs and enjoy doing Mobile Photography. In Short!? A Tech and Art enthusiast.",
    userImage: madhviAvatar,
    linkedIn: "https://www.linkedin.com/in/madhavisoni-903/",
    twitter: "https://twitter.com/madmandalic"
  },
  {
    id: 2,
    name: "Pranita Khaire",
    bio:
      "Pranita is pursuing engineering degree in Information Technology. She is a part of various college committes at campus and loves to contribute to them. She loves python programming and data science. She  is also interested in UI/UX.",
    userImage: pranitaAvatar,
    linkedIn: "https://www.linkedin.com/in/pranita-khaire-a31601149/",
    twitter: "https://twitter.com/PranitaKhaire/"
  }
];

const peopleManagementLeads = [
  {
    id: 1,
    name: "Ehtesham Siddiqui",
    bio:
      "Ehtesham is a technical enthusiast who always looks for ways to help more people get into tech and gain more knowledge about it. He loves exploring new tech always. Besides he is a JavaScript developer who also loves to play around with Python.",
    userImage: ehteshamAvatar,
    linkedIn: "https://www.linkedin.com/in/siddiquiehtesham/",
    twitter: "https://twitter.com/ehtesham___"
  },
  {
    id: 2,
    name: "Imran Sayed",
    bio:
      "Imran is enthusiastic about programming and is a fast learner. He likes to keep exploring new technologies and read about them. He is a web developer who works on frontend using the modern technologies like React and Gatsby.",
    userImage: imranAvatar,
    linkedIn: "https://www.linkedin.com/in/sayed-imran-08a498164/",
    twitter: "https://twitter.com/ImranSa56478546"
  }
];

export default function OurTeam() {
  return (
    <div className="p-3 main" id="our-team">
      <h3>Our Team</h3>
      <br />
      <br />
      <h4>Chapter Leaders</h4>
      <br />
      <div className="row">
        {chapterLeads.map(member => {
          return (
            <div className="col-sm-12 col-md-6 col-lg-6" key={member.id}>
              <Card
                name={member.name}
                about={member.bio}
                image={member.userImage}
                linkedIn={member.linkedIn}
                twitter={member.twitter}
              />
              <br />
            </div>
          );
        })}
      </div>
      <br />
      <br />
      <h4>People Management Leads</h4>
      <br />
      <div className="row">
        {peopleManagementLeads.map(member => {
          return (
            <div className="col-sm-12 col-md-6 col-lg-6" key={member.id}>
              <Card
                name={member.name}
                about={member.bio}
                image={member.userImage}
                linkedIn={member.linkedIn}
                twitter={member.twitter}
              />
              <br />
            </div>
          );
        })}
      </div>
    </div>
  );
}
